import { useState, useEffect, useCallback } from "react";
import { scoutAgentService } from "../../services/scoutAgentService";

// Agency custom labels (design 6a) — the shared, team-wide set (name + colour). One
// fetch feeds every label menu on the browse page; creating a label pushes it into
// the local list so the new swatch is immediately checkable without a refetch.
export const useAgencyLabels = () => {
  const [labels, setLabels] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchLabels = useCallback(async () => {
    setLoading(true);
    const res = await scoutAgentService.getLabels();
    if (res.success) setLabels(res.data);
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchLabels();
  }, [fetchLabels]);

  const createLabel = useCallback(async ({ name, color }) => {
    const res = await scoutAgentService.createLabel({ name, color });
    if (res.success) setLabels((prev) => [...prev, res.data].sort((a, b) => a.name.localeCompare(b.name)));
    return res;
  }, []);

  return { labels, loading, fetchLabels, createLabel };
};

export default useAgencyLabels;
